import { atom } from 'recoil';

export const bulkSelectedCompanyAtom = atom({
  key: 'bulkSelectedCompanyAtom',
  default: '',
});
